import { lazy as lazyLoad } from 'react';

import { route } from './constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    JobListPage: lazyLoad(async () => {
        const { JobListPage } = await import('./JobListPage');

        return { default: JobListPage };
    }),
};
export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.job-postings',
        page: lazy.JobListPage,
        path: route.patterns.jobs,
    },
];
